import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { adminAuthApi } from '../../services/adminApi';

interface Props {
  onLogin: () => void;
}

const AdminLoginPage: React.FC<Props> = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  // 바로 이동(/sso) 실패 안내 — 「admin 에서 다시 이동해 주세요」
  const location = useLocation();
  const [error, setError] = useState<string>((location.state as { message?: string } | null)?.message || '');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const data = await adminAuthApi.login(email, password);
      localStorage.setItem('hire_admin_token', data.accessToken);
      localStorage.setItem('hire_admin_email', email);
      onLogin();
    } catch (err: any) {
      setError(err.response?.data?.message || '로그인에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/grk-logo.jpg" alt="GRK Career Management" className="h-12 mx-auto object-contain" style={{ mixBlendMode: 'multiply' }} />
          <p className="mt-3 text-sm text-slate-500 tracking-widest uppercase">Career Admin</p>
        </div>
        <div className="bg-white rounded-2xl shadow-lg border border-slate-200 p-8">
          <h2 className="text-lg font-semibold text-slate-800 text-center mb-6">관리자 로그인</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1.5">이메일</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@grkcon.com" required
                className="w-full px-4 py-2.5 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1.5">비밀번호</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                className="w-full px-4 py-2.5 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent" />
            </div>
            {error && (
              <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-sm text-red-600">{error}</p>
              </div>
            )}
            <button type="submit" disabled={loading}
              className="w-full py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium rounded-lg transition-colors disabled:opacity-50">
              {loading ? '로그인 중...' : '로그인'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
